import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useFormikContext } from "formik";
import { createPortal } from "react-dom";
import useFocusErroringField from "@pro/js/store/accordion-registry/use-focus-erroring-field";
import PropTypes from "prop-types";

const SaveButton = ({ text = "Save", disabled = false, onSubmit }) => {
  const [portalContainer, setPortalContainer] = useState(null);
  const focusErroringField = useFocusErroringField();
  const formik = useFormikContext();

  useEffect(() => {
    const portalTarget = document.getElementById("save-button-portal");
    if (portalTarget) {
      setPortalContainer(portalTarget);
    }
  }, []);

  const scaleVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    exit: {
      scale: 0,
      opacity: 0,
      transition: { duration: 0.2, ease: "easeIn" },
    },
  };

  const clickHandler = () => {
    if (formik) {
      focusErroringField(formik.errors);
      formik.submitForm();
    } else if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <>
      {portalContainer &&
        createPortal(
          <motion.button
            className="btn btn-primary main-submit"
            disabled={
              disabled ||
              (typeof formik !== "undefined" ? formik.isSubmitting : false)
            }
            onClick={clickHandler}
            data-unsaved-changes={
              typeof formik !== "undefined" ? !!formik.dirty : false
            }
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={scaleVariants}
          >
            <span>{text}</span>
          </motion.button>,
          portalContainer
        )}
    </>
  );
};

SaveButton.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default SaveButton;
